import React, { useEffect, useState } from 'react';
import {
  Col,
  Modal,
  Row,
  Button,
  Tabs,
  Card,
  Input,
  InputNumber,
  Form,
  Divider,
  message,
} from 'antd';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import { QuestionOutlined } from '@ant-design/icons';
import * as finEngine from 'services/finEngine';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import InputRate from 'components/InputRate';
import AttributeList from './AttributeList';
import { ParOfferPricingAttributeResponse } from 'services/pricing';
import {
  PropElemAttributeResponse,
  PropElementResponse,
} from 'services/proposal';
import Text from 'antd/lib/typography/Text';
import { getRounding, toCurrency } from 'utils/utils';
import { dateToString } from 'utils/utils2';
import { useTranslation } from 'react-i18next';
import InputCurrency from 'components/InputCurrency/InputCurrency';
import { debounce } from 'lodash';
import { useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';

const { TabPane } = Tabs;

export type AttributeModalProps = {
  updateAttribute?: boolean;
  visible?: boolean;
  onClose?: any;
  params: any;
  onSave: (attribute: any, action: string) => void;
  attribute: PropElemAttributeResponse;
  finElement: PropElementResponse;
};

const AttributeModal = (props: any) => {
  const {
    visible = false,
    onClose,
    updateAttribute = false,
    params,
    onSave,
    attribute,
    finElement,
  } = props;

  const { t } = useTranslation();
  const [form] = useForm();
  const currcode = finElement?.currcode ?? localStorage.getItem('currcode') ?? '';

  const [disabled, setDisabled] = useState(true);
  const [offerpricing, setOfferpricing] = useState<any>();

  const [state, setstate] = useState<any>({
    installementamount: 0,
    duration: 0,
    pricing: {},
    attribte: updateAttribute ? attribute : INITIAL_VALUES,
  });

  const reset = () => {
    form?.setFieldsValue(INITIAL_VALUES);
  };

  useEffect(() => {
    if (attribute) {
      form?.setFieldsValue({
        attlabel:attribute.attlabel,
        attamount: attribute.attamount,
        attamountrequested:
          attribute?.attamountrequested ?? attribute.attamount,
        attamountmethod: attribute.attamountmethod,
        attcode: attribute.attcode,
        attcoef: attribute.attcoef,
        attcoefmax: attribute.attcoefmax,
        attcoefmin: attribute.attcoefmin,
        attexternalreference: attribute.attexternalreference,
        attid: attribute.attid,
        attmethod: attribute.attmethod,
        attnbdays: attribute.attnbdays,
        attrate: attribute.attrate,
        attraterequested: attribute.attraterequested ?? attribute.attrate,
        nbmonthsmax: attribute.nbmonthsmax,
        nbmonthsrequested: attribute.nbmonthsrequested ?? attribute.nbmonthsmax,
        attcomment: attribute.attcomment,
        attamountagreed: attribute.attamountagreed,
        atttype: attribute.atttype,
      });
    } else {
      if (offerpricing) {
        form?.setFieldsValue({
          attlabel:offerpricing.attlabel,
          attamount: offerpricing.attamountdefault,
          attamountrequested: offerpricing.attamountdefault,
          attamountmethod: offerpricing.attamountmethod,
          attcode: offerpricing.attcode,
          attcoef: offerpricing.attcoefdefault,
          attcoefmax: offerpricing.attcoefmax,
          attcoefmin: offerpricing.attcoefmin,
          attexternalreference: offerpricing.attexternalreference,
          attcomment: offerpricing.attcomment,
          attid: offerpricing.attid,
          attmethod: offerpricing.attmethod,
          attnbdays: offerpricing.attnbdays,
          attrate: offerpricing.attrate,
          attraterequested: offerpricing.attrate,
          nbmonthsmax:
            offerpricing.nbmonthsmax > finElement.cteduration
              ? finElement.cteduration
              : offerpricing.nbmonthsmax,
          nbmonthsrequested: 0, //offerpricing.nbmonthsmax,
          atttype: offerpricing.atttype,
          attstatus: offerpricing.status,
          attstatuslabel: offerpricing.statuslabel,
        });
      }
    }
  }, [attribute, form, visible, updateAttribute, offerpricing]);

  /* const updateAttribute = () => {
    const offer = { ofrid: 0, ofrlabel: '', ofrtype: '', ofrdescription: '' };
    const elem = pricingToElement(
      offer,
      state.servElement,
      cteinvestamount,
      0,
      0,
      0,
      cteidparent
    );
    const updatedobject = {
      ...elem,
      ...state.servElement,
      serviceResponse: {
        ...state.servElement.serviceResponse,
        additionalcostaftermargin: state.servElement.additionalcostaftermargin,
        marginoncalulatedamount: state.servElement.marginoncalulatedcamount,
        servfixedamount: state.servElement.servfixedamount,
        servpercentage: state.servElement.servpercentage,
      },
      conElemSchedules: schedule.schedule,
      cteinstallmentamount: state.installementamount,
      index: index,
    };

    return updatedobject;
  };
*/
  const setAttributeValues = () => {
    let attamountagreed = form?.getFieldValue('attamountagreed') ?? 0;

    let attamountmax = form?.getFieldValue('attamountmax') ?? 0;

    let attrequested = form.getFieldValue('attamountrequested') ?? 0;

    let status = 'REQVAL';
    let statuslabel = 'Request Validation';

    if (attrequested <= attamountagreed) {
      status = 'ACCEPT';
      statuslabel = 'Request Accepted';
      if(attribute) { attribute.attstatuslabel=statuslabel;}
    } else {
      if (attrequested <= attamountmax) {
        status = 'VALID';
        statuslabel = 'Validated';
        if(attribute) { attribute.attstatuslabel=statuslabel;}
      }
    }

    form.setFieldsValue({
      attamount: attrequested,
      nbmonthsmax: form.getFieldValue('nbmonthsrequested'),
      attstatus: status,
      attstatuslabel: statuslabel,
    });
  };
  const calculatePart = debounce(
    async (inField: string, attribute?: ParOfferPricingAttributeResponse) => {
      let attrate = form.getFieldValue('attraterequested') ?? 0;
      let nbmonths = form.getFieldValue('nbmonthsrequested') ?? 0;
      if (inField === 'INIT') {
        nbmonths = finElement.cteduration;
        if (attribute) attribute.nbmonthsmax = nbmonths;
      }
      if (attrate === 0 || nbmonths === 0) {
        form.setFieldsValue({ attamountrequested: 0 });
      } else {
        calculateInterest(finElement, attrate, nbmonths, inField, attribute);
      }
    },
    1000
  );

  const calculateInterest = async (
    finElement: PropElementResponse,
    inRate: number,
    inDuration: number,
    inField: string,
    attribute?: ParOfferPricingAttributeResponse
  ) => {
    finEngine
      .calculate({
        finReq: {
          inBillingDate: finElement?.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType:finElement?.ctecalculationtype,
          inCountingbasis: finElement?.cteratebasis,
          inDeferredMethod: 'NONE', //finElement?.ctedeferredinterestmethod,
          inDeferredRate: 0, //finElement?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElement?.ctedepositamount == null
              ? 0
              : finElement?.ctedepositamount,
          inDepositMethod: finElement?.ctedepositinterestmethod,
          inDepositRate:
            finElement?.ctedepositinterestmethod === 'NONE'
              ? 0
              : finElement?.ctedepositnominalrate == null
              ? 0
              : finElement?.ctedepositnominalrate,
          inDuration: inDuration,
          inFinancedAmount: finElement?.cteinvestamount,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: finElement?.ctefirstpayment,
          inGracePeriodDuration:
            finElement?.ctegraceperiodduration == null
              ? 0
              : finElement?.ctegraceperiodduration,
          inGracePeriodMethod: finElement?.ctegraceperiodmethod,
          inInstallmentAmount: finElement?.cteinstallmentamount,
          inInterestMethod: finElement?.cteinterestmethod,
          inPartAmount: 0,
          inPartMethod: 'NONE',
          inPartNbDays: 0,
          inPartRate: 0,
          inPeriodicity: finElement?.cteperiodicity,
          inPeriodicityUnit: finElement?.cteunit,
          inRatePeriodicity: Number(finElement?.cterateperiodicity),
          inRateType: finElement?.cteratetype,
          inRateValue: inRate,
          inResidualValue: finElement?.ctervamount,
          inRoundingAmount: getRounding(currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(finElement?.ctestartdate),
          inTaxcode: finElement?.taxcode,
          inTaxrate: finElement?.taxrate,
          inTaxtype: finElement?.taxtype,
          inTerm: finElement?.ctepaymentterm,
          inUpFrontAmount:
            finElement?.cteupfrontamount == null
              ? 0
              : finElement?.cteupfrontamount,
        },
      })
      .then((res: any) => {
        if (res.success) {
          message.success(t(`finEngine.${res.message}`));
          if (inField === 'INIT') {
            let ctepartamount = res.totalInterest;
            let attamountmax = attribute?.attamountmax ?? 0;

            if (ctepartamount > attamountmax) {
              ctepartamount = attamountmax;
            }
            form.setFieldsValue({ attamount: ctepartamount });
          } else {
            form.setFieldsValue({ attamountrequested: res.totalInterest.toFixed(2) });
          }
        }
      });
  };

  return (
    <div>
      <Modal
        visible={visible}
        title={updateAttribute ? 'Update Attribute' : 'Add Attribute'}
        onCancel={() => {
          onClose();
        }}
        width="1000px"
        style={{ top: 20 }}
        footer={null}
        destroyOnClose
      >
        <Card bordered>
          <Tabs
            type="card"
            tabBarExtraContent={
              <Row gutter={24}>
                <Col>
                  <Button key="Cancel" onClick={onClose}>
                    Cancel
                  </Button>
                </Col>
                <Col>
                  <Button
                    key="Validate"
                    type="primary"
                    onClick={() => {
                      onSave(
                        {
                          ...offerpricing,
                          ...attribute,
                          ...form?.getFieldsValue(),
                        },
                        updateAttribute ? 'update' : 'create'
                      );
                      onClose();
                    }}
                    icon={
                      updateAttribute ? (
                        <IUpdate color="white" height="16px" width="13px" />
                      ) : (
                        <IAdd
                          color="white"
                          width="14px"
                          height="14px"
                          svgStyle={{ marginTop: '3px' }}
                        />
                      )
                    }
                  >
                    {updateAttribute ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            }
          >
            <TabPane forceRender key={1} tab={<GetLabel label="Attribute" />}>
              <Form form={form} layout="vertical">
                <Card>
                  <Row>
                    <Row gutter={16}>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={12}
                        name="offerpricingattribute"
                      >
                        {updateAttribute ? (
                          <Text>{attribute?.attlabel + ' - ' + attribute.attcodelabel}</Text>
                        ) : (
                          <AttributeList
                            params={params}
                            onChange={(e: ParOfferPricingAttributeResponse) => {
                              setOfferpricing(e);
                              calculatePart('INIT', e);
                            }}
                            onClear={() => {
                              setOfferpricing(null);
                            }}
                          />
                        )}
                      </FormInput>

                      <FormInput col xs={24} lg={12} xl={6} name="atttype">
                        <ParListSelect
                          parcode="PRATTTYPE"
                          disabled={disabled}
                        />
                      </FormInput>

                      <FormInput col xs={24} lg={12} xl={6} name="attmethod">
                        <ParListSelect
                          parcode="PRATTMETH"
                          disabled={disabled}
                        />
                      </FormInput>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attmethod') === 'CREDF' && ( 
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="attnbdays"
                              >
                                <InputNumber disabled={disabled} />
                              </FormInput>
                            )
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attmethod') === 'CREDF' && ( 
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="attrate"
                              >
                                <InputRate disabled={disabled} />
                              </FormInput>
                            )
                          );
                        }}
                      </Form.Item>
                      <Row gutter={16}>
                        <FormInput
                          col
                          xs={24}
                          lg={24}
                          xl={24}
                          name="attamountmethod"
                        >
                          <ParListSelect
                            parcode="PRATTAMNT"
                            disabled={disabled}
                          />
                        </FormInput>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            return (
                              (getFieldValue('attamountmethod') === 'INT' || 
                                getFieldValue('attamountmethod') === 
                                  'INTCAP') && (
                                <>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="nbmonthsmax"
                                  >
                                    <InputNumber disabled={disabled} />
                                  </FormInput>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="attrate"
                                  >
                                    <InputRate disabled={disabled} />
                                  </FormInput>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="attamount"
                                  >
                                    <InputCurrency
                                      currcode={currcode}
                                      disabled={disabled}
                                    />
                                  </FormInput>
                                  <FormInput col xl={0} name="attstatus">
                                    <Input hidden />
                                  </FormInput>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="attstatuslabel"
                                  >
                                    <Text>
                                      {attribute
                                        ? attribute.attstatuslabel
                                        : offerpricing?.statuslabel}
                                    </Text>
                                  </FormInput>
                                </>
                              )
                            );
                          }}
                        </Form.Item>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            return (
                              (getFieldValue('attamountmethod') === 'INT' || 
                                getFieldValue('attamountmethod') === 
                                  'INTCAP') && (
                                <>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="nbmonthsrequested"
                                  >
                                    <InputNumber
                                      onChange={(e) => calculatePart('')}
                                    />
                                  </FormInput>
                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="attraterequested"
                                  >
                                    <InputRate
                                      onChange={(e) => calculatePart('')}
                                    />
                                  </FormInput>

                                  <FormInput
                                    col
                                    xs={24}
                                    lg={12}
                                    xl={6}
                                    name="attamountrequested"
                                  >
                                    <InputCurrency currcode={currcode} />
                                  </FormInput>
                                  <FormInput name="attamountagreed">
                                    {getFieldValue('attamountrequested') !==
                                      0 &&
                                    getFieldValue('attamountrequested') !==
                                      getFieldValue('attamount') ? (
                                      <Button
                                        icon={<QuestionOutlined />}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setAttributeValues();
                                        }}
                                        type="default"
                                      >
                                        <GetLabel label="Ask" />
                                      </Button>
                                    ) : (
                                      <Text>
                                        {toCurrency(
                                          attribute?.attamountagreed,
                                          localStorage.getItem('currcode') ?? ''
                                        )}
                                      </Text>
                                    )}
                                  </FormInput>
                                </>
                              )
                            );
                          }}
                        </Form.Item>
                      </Row>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            (getFieldValue('attamountmethod') === 'PERC' || 
                              getFieldValue('attamountmethod') === 
                                'PERCCAP') && (
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoef"
                                >
                                  <InputNumber
                                    disabled={
                                      attribute
                                        ? !attribute.flagupdate
                                        : !offerpricing?.flagupdate
                                    }
                                    onChange={(e: any) =>
                                      form.setFieldsValue({
                                        attamount:
                                          (e * finElement.cteinvestamount) /
                                          100,
                                      })
                                    }
                                  />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamount"
                                >
                                  <InputCurrency
                                    currcode={currcode}
                                    disabled={
                                      attribute
                                        ? !attribute.flagupdate
                                        : !offerpricing?.flagupdate
                                    }
                                    onChange={(e: any) =>
                                      form.setFieldsValue({
                                        attcoef:
                                          (e / finElement.cteinvestamount) *
                                          100,
                                      })
                                    }
                                  />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attstatuslabel"
                                >
                                  <Text>
                                    {attribute
                                      ? attribute?.attstatuslabel
                                      : offerpricing?.statuslabel}
                                  </Text>
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>
                      <Divider />
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attexternalreference"
                      >
                        <Input disabled={disabled} />
                      </FormInput>
                      <FormInput col xs={18} name="attcomment">
                        <TextArea rows={3}>
                          {attribute
                            ? attribute.attcomment
                            : offerpricing?.attcomment}
                        </TextArea>
                      </FormInput>
                    </Row>
                  </Row>
                </Card>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </Modal>
    </div>
  );
};

const INITIAL_VALUES = {
  attamountdefault: 0,
  attamountmax: 0,
  attamountmethod: '',
  attamountmin: 0,
  attcode: '',
  attcoefdefault: 0,
  attcoefmax: 0,
  attcoefmin: 0,
  attdirection: '',
  attexternalreference: '',
  attid: 0,
  attmethod: '',
  attnbdays: 0,
  attrate: 0,
  atttype: '',
  flagaddmanual: true,
  flagdelete: true,
  flagupdate: true,
  offerid: 0,
  priid: 0,
  proccode: '',
  requestreceiverid: 0,
  requestreceiverroleprofile: '',
  requestreceivertype: '',
  requesttype: '',
  taskid: 0,
  tpid: 0,
  tprole: '',
};

export default AttributeModal;
